module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "trackForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "0px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "xy-title"
  }, [_c('b', [_vm._v("运单查询")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入运单单号(最多10个),用回车键分隔"
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    },
    model: {
      value: (_vm.form.bills),
      callback: function($$v) {
        _vm.$set(_vm.form, "bills", $$v)
      },
      expression: "form.bills"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "native-type": "submit",
      "size": "mini",
      "icon": "el-icon-search"
    }
  }, [_vm._v("查询")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f81437b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/xy-track-form.vue
// module id = 722
// module chunks = 1